module.exports = __webpack_public_path__ + "static/media/Highland Ave San Carlos, CA8.bfe660e8.jpg";